let globalPublicApi;
let globalConfiguration;
let globalStrategy;
const onRumInitSubscribers = [];
const onRumStartSubscribers = [];
export function reactPlugin(configuration = {}) {
    return {
        name: 'react',
        onInit({ publicApi, initConfiguration }) {
            globalPublicApi = publicApi;
            globalConfiguration = configuration;
            for (const subscriber of onRumInitSubscribers) {
                subscriber(globalConfiguration, globalPublicApi);
            }
            if (configuration.router) {
                initConfiguration.trackViewsManually = true;
            }
        },
        onRumStart({ strategy }) {
            globalStrategy = strategy;
            for (const subscriber of onRumStartSubscribers) {
                subscriber(strategy);
            }
        },
        getConfigurationTelemetry() {
            return { router: !!configuration.router };
        },
    };
}
export function onRumInit(callback) {
    if (globalConfiguration && globalPublicApi) {
        callback(globalConfiguration, globalPublicApi);
    }
    else {
        onRumInitSubscribers.push(callback);
    }
}
export function onRumStart(callback) {
    if (globalStrategy) {
        callback(globalStrategy);
    }
    else {
        onRumStartSubscribers.push(callback);
    }
}
export function resetReactPlugin() {
    globalPublicApi = undefined;
    globalConfiguration = undefined;
    globalStrategy = undefined;
    onRumInitSubscribers.length = 0;
    onRumStartSubscribers.length = 0;
}
//# sourceMappingURL=reactPlugin.js.map